<template>
	<span>
		<DatePoint :date="rangeBorders.start"
			:isHideMark="!isCurrentRangeIncludeStart"
			:index="1"
			:pairedIndex="selectedDateRange.daysCount == 1 ? undefined : 2"
			:baseLeft="baseLeft" 
			:daysCount="selectedDateRange.daysCount"
			:itemsContainer="itemsContainer" 
			:weekItemWidth="weekItemWidth" 
			:weekItemHeight="weekItemHeight"
			:deltaDates="deltaDates"
			:currentRange="currentRange"/>
		
		<DatePoint v-if="selectedDateRange.daysCount != 1" 
			:isHideMark="!isCurrentRangeIncludeEnd"
			:date="rangeBorders.end"
			:index="2"
			:pairedIndex="1"
			:baseLeft="baseLeft" 
			:daysCount="selectedDateRange.daysCount"
			:itemsContainer="itemsContainer" 
			:weekItemWidth="weekItemWidth" 
			:weekItemHeight="weekItemHeight"
			:deltaDates="deltaDates"
			:currentRange="currentRange"/>
	</span>
</template>

<script>
import CalendarMonth from '../../../../scripts/calendarMonth';
import CalendarWeek from '../../../../scripts/calendarWeek';
import { isEqualDate, nextDate } from '../../../../scripts/date';
import SelectedDateRange from '../../../../scripts/selectedDateRange';
import DatePoint from './DatePoint.vue';

export default {
	name: 'WeekSelectedDays',
	components: {
		DatePoint,
	},
	props: {
		selectedDateRange: {
			type: SelectedDateRange,
			required: true,
		},
		currentRange: {	
			type: CalendarWeek|CalendarMonth,
			required: true,
		},
		itemsContainer: {
			type: HTMLElement,
		},
		collapseStep: {
			type: Number,
			required: true,
		},
		carouselIndex: {
			type: Number,
			required: true,
		},
		deltaDates: {
			type: Number,
		},
	},
	computed: {

        isRangeWeek(){
            return this.currentRange instanceof CalendarWeek
        },
		
		weekItem(){
			this.collapseStep
			return document.querySelector('.schedule-date')
		},

		baseLeft(){
			this.collapseStep
			if (!this.itemsContainer)
				return 0
			const containerWidth = this.itemsContainer.offsetWidth
			return containerWidth * this.carouselIndex
		},
		selectedWeekDay(){
			this.collapseStep
			const value = this.selectedDateRange.start.date.getDay()
			return value == 0 ? 6 : value - 1
		},
		rangeBorders(){
			return {
				start: new Date(this.selectedDateRange.start.date),
				end: new Date(this.selectedDateRange.end.date),
			}
		},

		isCurrentRangeIncludeStart(){
			this.collapseStep
			if (!this.currentRange)
				return false
			return this.currentRange.includes(this.rangeBorders.start)
		},
		
		isCurrentRangeIncludeEnd(){
			this.collapseStep
			if (!this.currentRange)
				return false
			return this.currentRange.includes(this.rangeBorders.end)
		},
	},

	data() {
		return {
			weekItemWidth: 0,
			weekItemHeight: 0,
			updateInterval: null,
			isMounted: false,
		}
	},

	mounted() {
		this.isMounted = true
		this.setupSizes()
	},

	beforeDestroy() {
		if (this.updateInterval) {
			clearInterval(this.updateInterval)
		}
	},

	methods:{

		setupSizes(){
			this.updateInterval = setInterval(() => {
				const size = this.getItemSize()
				if (size && size.width != null && size.width > 10) {
					this.weekItemWidth = Number(size.width.toFixed(1))
					this.weekItemHeight = Number(size.height.toFixed(1))
					clearInterval(this.updateInterval)
				}
			})
		},

		getItemSize(){
			if (!this.itemsContainer)
				return null

			const scheduleDates = Array.from(this.itemsContainer.querySelectorAll('.schedule-date'))
			if (scheduleDates.length == 0)
				return null
			const visibleScheduleDate = scheduleDates.find(elem => elem.style.display != 'none' && elem.offsetWidth)
			if (!visibleScheduleDate)
				return null
			const rect = visibleScheduleDate.getBoundingClientRect()
			return rect
		},

	}
}
</script>

<style scoped>
.selected-date-range-mark{
	position: absolute;
	height: calc(100% - 4px);
	border: 1px solid  #0075ff;
	box-shadow: 0 0 0 1.5px #adcdf3;
	border-radius: 4px;
	display: none;
	/* cubic-bezier(0.175, 0.885, 0.32, 1.275) */
	/* transition: all .3s ease; */
}

</style>